import React from "react";
import BaseDefault from "../core/BaseDefault";

export default function Tables_Page(){
    return(
        <BaseDefault 
            styles="title-page"
            title="Tables"
        >
            
        </BaseDefault>
    )
}